export default function PageHero({ overline, title, subtitle, accentWord }) {
  const renderTitle = () => {
    if (!accentWord) return title;
    const parts = title.split(accentWord);
    return (
      <>
        {parts[0]}
        <span className="hand-underline active">{accentWord}</span>
        {parts[1] || ""}
      </>
    );
  };

  return (
    <section
      data-testid="page-hero"
      className="pt-32 md:pt-44 pb-12 md:pb-20 bg-cream"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        {overline && (
          <p className="text-xs uppercase tracking-[0.25em] font-body font-medium text-stone-dark mb-6 animate-fade-up">
            {overline}
          </p>
        )}
        <h1
          data-testid="page-hero-title"
          className="font-headings text-5xl sm:text-6xl lg:text-7xl text-ink tracking-tight leading-[1.02] max-w-4xl animate-fade-up delay-100"
        >
          {renderTitle()}
        </h1>
        {subtitle && (
          <p
            data-testid="page-hero-subtitle"
            className="mt-8 font-body text-lg md:text-xl text-ink-700 max-w-2xl leading-relaxed animate-fade-up delay-200"
          >
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
